import Crud from '../views/Cbo/Crud'
import Entity from '../views/Cbo/View'

let routes = {
    path: '/cbos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cbos/view/:id?',
            name: 'ViewCbo',
            component: Entity,
            meta: {
                pageTitle: "Visualizar CBO",
                breadcrumb: [
                    {
                        text: "CBO's",
                        active: false,
                        to: '/cbos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/cbos',
            name: 'list-cbos',
            component: Crud,
            meta: {
                pageTitle: "Lista de CBO's",
                breadcrumb: [
                    {
                        text: "CBO's",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
